/**
 * Fetch bus device configs (RS485/CAN) for a gateway.
 */
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { GatewayDeviceConfig } from '@/types/gateway';

export function useGatewayDeviceConfigs(deviceId: string | undefined) {
  const query = useQuery({
    queryKey: ['gateway-device-configs', deviceId],
    queryFn: async (): Promise<GatewayDeviceConfig[]> => {
      if (!deviceId) return [];
      const { data, error } = await supabase
        .from('gateway_device_configs')
        .select('*')
        .eq('gateway_device_id', deviceId)
        .order('bus_address', { ascending: true });
      if (error) throw new Error(error.message);
      return (data ?? []) as GatewayDeviceConfig[];
    },
    enabled: Boolean(deviceId),
    staleTime: 30_000,
    refetchInterval: 30_000,
  });

  return {
    configs: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
